import { ActionTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import LanguagesState from '../types/LanguagesState'
import * as types from './mutation-types'
import i18n from '@vue-storefront/i18n'
import { setCookieCSR } from '@vue-storefront/core/scripts/utils/cookies';

const actions: ActionTree<LanguagesState, RootState> = {
  changesCurrenLanguage ({ commit, state }, language) {
    i18n.locale = language
    i18n.fallbackLocale = language
    setCookieCSR({ key: 'shop/languages/language', value: language, days: 365 })
    commit(types.CHANGES_LANGUAGE, language)
  }
}

export default actions
